/**
 * Axios instance with 401 handling.
 * Use for API calls - 401 responses redirect to login (except auth endpoints).
 * Also patches default axios so any axios request gets 401 handling.
 */
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { clearToken } from './auth';

const handle401Response = async (error) => {
  const status = error.response?.status;
  const url = error.config?.url || error.config?.baseURL || '';
  const isAuthEndpoint = url.includes('/api/auth/login') || url.includes('/api/auth/register');

  if (status === 401 && !isAuthEndpoint) {
    clearToken();
    window.location.href = '/login';
    return Promise.reject(error);
  }

  return Promise.reject(error);
};

// Patch default axios so ALL axios requests get 401 handling (including from dependencies)
axios.interceptors.response.use((r) => r, handle401Response);

const api = axios.create({
  baseURL: API_BASE_URL || undefined,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use((r) => r, handle401Response);

export default api;
